import Cookies from "js-cookie";
/**
 * Cookie Defaults
 * @type {{domain:(string|string|*), sameSite:string, secure:boolean}}
 */
const cookieOpts = {
    domain: window.location.hostname,
    secure: true,
    sameSite: "strict",
};

/**
 * Parses the browser's cookies
 * @type {any}
 */
export const cookieApi = Cookies.withConverter({
    read: value => JSON.parse(Cookies.converter.read(value)),
    write: value => Cookies.converter.write(JSON.stringify(value))
});

/**
 * Uses js-cookie to get a browser cookie
 *
 * @param {String} name The name of the Cookie to fetch
 *
 * @link https://github.com/js-cookie/js-cookie?tab=readme-ov-file#basic-usage
 * @returns {*}
 */
export const getCookie = (name) => cookieApi.get(name)

/**
 * Removes a specific cookie by name
 * @param {String} name The cookie name
 *
 * @link https://github.com/js-cookie/js-cookie?tab=readme-ov-file#basic-usage
 * @returns {*}
 */
export const removeCookie = (name) => cookieApi.remove(name);

/**
 * Uses js-cookie to set a browser cookie
 * @param {String} name The name of the Cookie to set
 * @param {String|Array|Object} value The value to set for the Cookie
 * @param {Object} params Any parameters for the Cookie
 *
 * @link https://github.com/js-cookie/js-cookie?tab=readme-ov-file#basic-usage
 * @returns {*}
 */
export const setCookie = (name, value = '', params = {}) => cookieApi.set(name, value, cookieOpts)

